<template>
  <v-dialog v-model="showDialogCreateQuickResponse" width="420" persistent>
    <v-card>
      <div class="quick-response-dialog-header">
        <div class="quick-response-dialog-title">
          {{ $t('createNewQuickResponse') | capitalize }}
        </div>
        <v-spacer></v-spacer>
        <v-btn flat icon @click="cancel">
          <v-icon color="#8B8FA3">mdi-close</v-icon>
        </v-btn>
      </div>
      <v-form ref="createQuickResponseForm" class="quick-response-form">
        <v-text-field v-model="_id" style="display: none"/>
        <v-text-field v-model="type" style="display: none"/>
        <v-text-field
            v-model="title"
            background-color="#D6D9E6"
            flat
            single-line
            outline
            height="37px"
            :rules="[formRules.ruleRequired, formRules.ruleCounter(100), formRules.ruleAgentQuickResponseTitle]"
            :placeholder="$t('quickResponseForm.title') | capitalize"/>
        <v-text-field
            v-if="type===1"
            v-model="group"
            background-color="#D6D9E6"
            flat
            single-line
            outline
            height="37px"
            :rules="formRules.required"
            :placeholder="$t('quickResponseForm.group') | capitalize"/>
        <v-textarea
            v-model="content"
            ref="blockReason"
            background-color="#D6D9E6"
            auto-grow
            flat
            outline
            rows="5"
            :rules="formRules.required"
            :placeholder="$t('quickResponseForm.content') | capitalize"
            :hide-details="hideDetails"
        ></v-textarea>
        <div class="variable-picker">
          <div class="variable-item" v-for="item of Object.keys(crmData)" @click="onAddVariable(item)">
            <span>{{item}}</span>
          </div>
        </div>
        <div class="dialog-action">
          <v-btn small outline color="#0052CC" style="margin-left: auto" @click="cancel">{{$t('cancel') | capitalize}}</v-btn>
          <v-btn small color="#0052CC" class="white--text" @click="submit">{{$t('save') | capitalize}}</v-btn>
        </div>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapState} from "vuex";
import FormMixin from "@/mixins/FormMixin";
import {mapFields} from "vuex-map-fields";

export default {
  name: "DialogCreateQuickResponse",
  mixins: [FormMixin],
  data() {
    return {
      hideDetails: true
    }
  },
  computed: {
    ...mapState('dialog', ['showDialogCreateQuickResponse']),
    ...mapFields('agentQuickResponse', ['title', 'content', "_id", "type", "group"]),
    ...mapState('crm', ['crmData'])
  },
  methods: {
    ...mapActions('dialog', ['closeDialogCreateQuickResponse']),
    ...mapActions('agentQuickResponse', ['saveAgentQuickResponse', 'updateQuickResponse']),
    submit() {
      if (this.$refs.createQuickResponseForm.validate()) {
        //Update
        if (this._id) {
          this.updateQuickResponse(this.type)
        }
        //Create
        else {
          this.saveAgentQuickResponse()
        }
        this.$refs.createQuickResponseForm.reset()
      }
      else {
        this.hideDetails = false
      }
    },
    cancel() {
      this.$refs.createQuickResponseForm.reset()
      this.hideDetails = true;
      this.closeDialogCreateQuickResponse()
    },
    onAddVariable(item) {
      if(this.content  !== undefined) {
        this.content = this.content + `{${item}}`
      }
      else {
        this.content = `{${item}}`
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "components/style/dialog-create-quick-response";
</style>
